import React, { useRef, useEffect } from "react";
import Images from "../../Components/Atoms/Images";
import researches from "../../assets/ShopxAssets/Researches.svg";
import gsap from "gsap/all";
import { Linear } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function ResearchSvg() {
  let Ellipse_773 = useRef(null);
  let Ellipse_778 = useRef(null);
  let Ellipse_779 = useRef(null);

  let tl = gsap.timeline({
    defaults: {
      scrollTrigger: {
        trigger: ".research__image",
        start: "+=500",
        end: "+=500",
        markers: false,
        animate: "none none none reverse",
      },
    },
  });

  // useEffect(() => {

  //     tl.to("#Ellipse_773", { scale:1, transformOrigin: "center", border:"2px solid red" }, 1)

  // }, [])

  return (
    <div className="shopx__wrapper__partial research__image top__margin padding__bottom padding">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1364 1269.827"
        id="svgg"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_11"
              data-name="Rectangle 11"
              width="226"
              height="170"
              rx="53"
              transform="translate(1170 5137)"
              fill="#fff"
            />
          </clipPath>
          <clipPath id="clip-path-2">
            <rect
              id="Rectangle_11-2"
              data-name="Rectangle 11"
              width="226"
              height="170"
              rx="53"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Group_7362"
          data-name="Group 7362"
          transform="translate(-327.094 -7937)"
        >
          <g
            id="Group_7359"
            data-name="Group 7359"
            transform="translate(33.094 -652.5)"
          >
            <g
              id="Group_7247"
              data-name="Group 7247"
              transform="translate(7564 24780.5)"
            >
              <g
                ref={Ellipse_773}
                id="Ellipse_773"
                data-name="Ellipse 773"
                transform="translate(-6691 -15845)"
                fill="none"
                stroke="#e3334a"
                stroke-linecap="round"
                stroke-width="6"
                stroke-dasharray="10 20"
              >
                <ellipse
                  cx="238.5"
                  cy="242"
                  rx="238.5"
                  ry="242"
                  stroke="none"
                />
                <ellipse cx="238.5" cy="242" rx="235.5" ry="239" fill="none" />
              </g>
              <g
                ref={Ellipse_778}
                id="Ellipse_778"
                data-name="Ellipse 778"
                transform="translate(-6820 -15609)"
                fill="none"
                stroke="#00a651"
                stroke-linecap="round"
                stroke-width="6"
                stroke-dasharray="10 20"
              >
                <ellipse
                  cx="238.5"
                  cy="242"
                  rx="238.5"
                  ry="242"
                  stroke="none"
                />
                <ellipse cx="238.5" cy="242" rx="235.5" ry="239" fill="none" />
              </g>
              <g
                ref={Ellipse_779}
                id="Ellipse_779"
                data-name="Ellipse 779"
                transform="translate(-6962 -15846)"
                fill="none"
                stroke="#fdb913"
                stroke-linecap="round"
                stroke-width="6"
                stroke-dasharray="10 20"
              >
                <ellipse
                  cx="238.5"
                  cy="241.5"
                  rx="238.5"
                  ry="241.5"
                  stroke="none"
                />
                <ellipse
                  cx="238.5"
                  cy="241.5"
                  rx="235.5"
                  ry="238.5"
                  fill="none"
                />
              </g>
            </g>
            <path
              id="Path_6800"
              data-name="Path 6800"
              d="M-21.708,0h2.592l-2.568-16.44h-2.544L-28.86-3.312-33.516-16.44h-2.592L-38.676,0h2.592l1.776-11.568L-30.2,0h2.64l4.1-11.52Zm10.776-8.688a2.821,2.821,0,0,1,1.56.432,3.282,3.282,0,0,1,1.488,2.88A3.413,3.413,0,0,1-8.292-3.7a2.918,2.918,0,0,1-2.64,1.608,2.855,2.855,0,0,1-1.536-.432A3.209,3.209,0,0,1-13.98-5.376a3.646,3.646,0,0,1,.408-1.7A2.918,2.918,0,0,1-10.932-8.688ZM-7.98,0h2.5V-10.776H-7.692l-.216,1.2a4.478,4.478,0,0,0-3.36-1.44,5.123,5.123,0,0,0-2.688.72,5.661,5.661,0,0,0-2.568,4.92,5.917,5.917,0,0,0,.7,2.856A5.039,5.039,0,0,0-11.268.24,4.586,4.586,0,0,0-7.98-1.1ZM3.276-8.352a2.588,2.588,0,0,1,.936.216l.024-2.472a.64.64,0,0,0-.312-.12H3.852L3.66-10.7A3.98,3.98,0,0,0,.732-9.576v-1.2H-1.74V0H.732V-6.912A3,3,0,0,1,3.276-8.352ZM14.268,0h3.024L11.844-6.456l4.872-4.488-3.072-.024L9.4-7.1V-16.92H6.852V0H9.4V-4.536l.624-.5Zm6.96-6.552a2.883,2.883,0,0,1,2.688-2.184,2.915,2.915,0,0,1,2.736,2.184ZM29.2-4.3a8.139,8.139,0,0,0,.1-1.08,5.8,5.8,0,0,0-.72-2.856,5.251,5.251,0,0,0-4.656-2.784,5.069,5.069,0,0,0-2.712.744,5.651,5.651,0,0,0-2.664,4.9,5.6,5.6,0,0,0,.744,2.832A5.593,5.593,0,0,0,24.156.24a6.962,6.962,0,0,0,4.7-1.776L27.3-3.264A4.523,4.523,0,0,1,24.132-2.04,3.09,3.09,0,0,1,21.2-4.3Zm3.768-6.576-2.256.12v2.184h2.136v4.776c0,2.5,1.392,4.032,3.624,4.032a4.4,4.4,0,0,0,3.216-1.464l-1.32-1.824a2.525,2.525,0,0,1-1.656.912c-.792,0-1.32-.6-1.32-1.68V-8.568h3.528v-2.3H35.388v-2.976h-2.16Zm-71.94,30.52a2.588,2.588,0,0,1,.936.216l.024-2.472a.64.64,0,0,0-.312-.12H-38.4l-.192.024a3.98,3.98,0,0,0-2.928,1.128v-1.2h-2.472V28h2.472V21.088A3,3,0,0,1-38.976,19.648Zm5.472,1.8a2.883,2.883,0,0,1,2.688-2.184,2.915,2.915,0,0,1,2.736,2.184Zm7.968,2.256a8.139,8.139,0,0,0,.1-1.08,5.8,5.8,0,0,0-.72-2.856,5.251,5.251,0,0,0-4.656-2.784,5.069,5.069,0,0,0-2.712.744,5.651,5.651,0,0,0-2.664,4.9,5.6,5.6,0,0,0,.744,2.832,5.593,5.593,0,0,0,4.872,2.784,6.962,6.962,0,0,0,4.7-1.776l-1.56-1.728A4.523,4.523,0,0,1-30.6,25.96,3.09,3.09,0,0,1-33.528,23.7Zm1.728,2.784A6.556,6.556,0,0,0-19.44,28.24c2.424,0,4.08-1.32,4.08-3.36,0-1.7-1.08-2.76-3.264-3.408a6.64,6.64,0,0,1-1.776-.7.806.806,0,0,1-.408-.7c0-.576.48-.96,1.368-.96a3.84,3.84,0,0,1,2.5,1.128l1.32-1.848a5.815,5.815,0,0,0-3.792-1.416c-2.208,0-3.792,1.224-3.792,3.12,0,1.8,1.032,2.784,3.5,3.528a7.2,7.2,0,0,1,1.608.624.841.841,0,0,1,.336.672c0,.672-.624,1.152-1.68,1.152a4.227,4.227,0,0,1-3.024-1.464Zm13.176-5.04a2.883,2.883,0,0,1,2.688-2.184,2.915,2.915,0,0,1,2.736,2.184ZM-2.664,23.7a8.139,8.139,0,0,0,.1-1.08,5.8,5.8,0,0,0-.72-2.856,5.251,5.251,0,0,0-4.656-2.784,5.069,5.069,0,0,0-2.712.744,5.651,5.651,0,0,0-2.664,4.9,5.6,5.6,0,0,0,.744,2.832A5.593,5.593,0,0,0-7.7,28.24,6.962,6.962,0,0,0-3,26.464l-1.56-1.728A4.523,4.523,0,0,1-7.728,25.96,3.09,3.09,0,0,1-10.656,23.7Zm7.68-4.392a2.821,2.821,0,0,1,1.56.432,3.282,3.282,0,0,1,1.488,2.88,3.413,3.413,0,0,1-.408,1.68,2.918,2.918,0,0,1-2.64,1.608A2.855,2.855,0,0,1,3.48,25.48a3.209,3.209,0,0,1-1.512-2.856,3.646,3.646,0,0,1,.408-1.7A2.918,2.918,0,0,1,5.016,19.312ZM7.968,28h2.5V17.224H8.256l-.216,1.2a4.478,4.478,0,0,0-3.36-1.44,5.123,5.123,0,0,0-2.688.72,5.661,5.661,0,0,0-2.568,4.92,5.917,5.917,0,0,0,.7,2.856,5.039,5.039,0,0,0,4.56,2.76A4.586,4.586,0,0,0,7.968,26.9Zm11.256-8.352a2.588,2.588,0,0,1,.936.216l.024-2.472a.64.64,0,0,0-.312-.12H19.8l-.192.024a3.98,3.98,0,0,0-2.928,1.128v-1.2H14.208V28H16.68V21.088A3,3,0,0,1,19.224,19.648Zm3.552,5.832A5.356,5.356,0,0,0,27.6,28.24,5.894,5.894,0,0,0,31.968,26.3l-1.656-1.7a3.788,3.788,0,0,1-2.712,1.32,2.855,2.855,0,0,1-1.536-.432,3.241,3.241,0,0,1-1.488-2.856,3.646,3.646,0,0,1,.408-1.7A2.883,2.883,0,0,1,27.6,19.312a3.66,3.66,0,0,1,2.5,1.128l1.656-1.728A6.042,6.042,0,0,0,27.6,16.984a5.461,5.461,0,0,0-2.832.72,5.516,5.516,0,0,0-2.736,4.92A5.7,5.7,0,0,0,22.776,25.48ZM41.664,28h2.52V21.64c0-2.976-1.56-4.824-4.152-4.824a4.285,4.285,0,0,0-3.144,1.44V11.08H34.344V28h2.544V20.992A3.205,3.205,0,0,1,39.5,19.216c1.344,0,2.16.96,2.16,2.664Z"
              transform="translate(976 9253.5)"
              fill="#241a1b"
            />
            <path
              id="Path_6801"
              data-name="Path 6801"
              d="M-133.524-12.888l2.568,6.408h-5.136ZM-128.364,0h2.784l-6.672-16.44H-134.7L-141.4,0h2.712l1.608-4.056H-130Zm12.312,0h2.544V-6.288c0-2.952-1.56-4.728-4.176-4.728a4.466,4.466,0,0,0-3.24,1.536l-.24-1.3h-2.208V0h2.544V-6.912a3.229,3.229,0,0,1,2.64-1.728c1.344,0,2.136.96,2.136,2.616Zm10.92-8.688a2.821,2.821,0,0,1,1.56.432,3.282,3.282,0,0,1,1.488,2.88,3.413,3.413,0,0,1-.408,1.68,2.918,2.918,0,0,1-2.64,1.608,2.855,2.855,0,0,1-1.536-.432,3.209,3.209,0,0,1-1.512-2.856,3.646,3.646,0,0,1,.408-1.7A2.918,2.918,0,0,1-105.132-8.688ZM-102.18,0h2.5V-10.776h-2.208l-.216,1.2a4.478,4.478,0,0,0-3.36-1.44,5.123,5.123,0,0,0-2.688.72,5.661,5.661,0,0,0-2.568,4.92,5.917,5.917,0,0,0,.7,2.856,5.039,5.039,0,0,0,4.56,2.76A4.586,4.586,0,0,0-102.18-1.1Zm6.072,0h2.544V-16.92h-2.544Zm10.536,5.04a6.261,6.261,0,0,0,2.928-.672,4.267,4.267,0,0,0,2.016-3V-10.776H-83.2v7.1a3.068,3.068,0,0,1-2.52,1.656c-1.32,0-2.04-.864-2.04-2.472v-6.288H-90.3v6.552c0,2.88,1.488,4.608,4.056,4.608a3.83,3.83,0,0,0,3.312-1.44c.024.216.024.528.024.912-.024,1.848-.408,2.472-1.176,2.64a11.2,11.2,0,0,1-2.088.24c-.984.048-1.608-.24-2.952-1.3l-1.248,1.968A6.627,6.627,0,0,0-85.572,5.04Zm7.68-6.552A6.556,6.556,0,0,0-73.524.24c2.424,0,4.08-1.32,4.08-3.36,0-1.7-1.08-2.76-3.264-3.408a6.64,6.64,0,0,1-1.776-.7.806.806,0,0,1-.408-.7c0-.576.48-.96,1.368-.96a3.84,3.84,0,0,1,2.5,1.128l1.32-1.848A5.815,5.815,0,0,0-73.5-11.016c-2.208,0-3.792,1.224-3.792,3.12,0,1.8,1.032,2.784,3.5,3.528a7.2,7.2,0,0,1,1.608.624.841.841,0,0,1,.336.672c0,.672-.624,1.152-1.68,1.152a4.227,4.227,0,0,1-3.024-1.464ZM-66.78,0h2.544V-10.92H-66.78Zm-.168-14.064a1.554,1.554,0,0,0,1.416,1.632,1.556,1.556,0,0,0,1.44-1.632,1.556,1.556,0,0,0-1.44-1.632A1.554,1.554,0,0,0-66.948-14.064Zm5.136,12.552A6.556,6.556,0,0,0-57.444.24c2.424,0,4.08-1.32,4.08-3.36,0-1.7-1.08-2.76-3.264-3.408a6.64,6.64,0,0,1-1.776-.7.806.806,0,0,1-.408-.7c0-.576.48-.96,1.368-.96a3.84,3.84,0,0,1,2.5,1.128l1.32-1.848a5.815,5.815,0,0,0-3.792-1.416c-2.208,0-3.792,1.224-3.792,3.12,0,1.8,1.032,2.784,3.5,3.528a7.2,7.2,0,0,1,1.608.624.841.841,0,0,1,.336.672c0,.672-.624,1.152-1.68,1.152a4.227,4.227,0,0,1-3.024-1.464Zm21.384-7.176a2.821,2.821,0,0,1,1.56.432,3.254,3.254,0,0,1,1.488,2.88,3.549,3.549,0,0,1-.408,1.68,2.918,2.918,0,0,1-2.64,1.608,2.855,2.855,0,0,1-1.536-.432,3.209,3.209,0,0,1-1.512-2.856,3.331,3.331,0,0,1,.432-1.7A2.883,2.883,0,0,1-40.428-8.688Zm0,8.928A5.7,5.7,0,0,0-37.572-.5a5.439,5.439,0,0,0,2.736-4.872,5.856,5.856,0,0,0-.72-2.9,5.439,5.439,0,0,0-4.872-2.736,5.674,5.674,0,0,0-2.856.72,5.516,5.516,0,0,0-2.736,4.92,5.7,5.7,0,0,0,.744,2.856A5.421,5.421,0,0,0-40.428.24Zm8.976-12.912a15.572,15.572,0,0,0,.1,1.728l-1.944.12V-8.64h2.208V0h2.52V-8.64h3.24v-2.3H-28.86V-12.96c0-1.32.336-1.824,1.2-1.824.48,0,.72.144,1.56.888l1.248-1.9a4.681,4.681,0,0,0-3.1-1.368C-30.276-17.16-31.452-15.672-31.452-12.672ZM-6.2,0l4.656-10.776H-4.14L-7.428-3.1l-2.328-7.68h-1.68L-13.62-2.952l-3.312-7.824H-19.62L-14.988,0h2.544l1.872-6.528L-8.724,0ZM5.244-8.688a2.821,2.821,0,0,1,1.56.432,3.254,3.254,0,0,1,1.488,2.88A3.549,3.549,0,0,1,7.884-3.7a2.918,2.918,0,0,1-2.64,1.608A2.855,2.855,0,0,1,3.708-2.52,3.209,3.209,0,0,1,2.2-5.376a3.331,3.331,0,0,1,.432-1.7A2.883,2.883,0,0,1,5.244-8.688Zm0,8.928A5.7,5.7,0,0,0,8.1-.5a5.439,5.439,0,0,0,2.736-4.872,5.856,5.856,0,0,0-.72-2.9,5.439,5.439,0,0,0-4.872-2.736,5.674,5.674,0,0,0-2.856.72A5.516,5.516,0,0,0-.348-5.376,5.7,5.7,0,0,0,.4-2.52,5.421,5.421,0,0,0,5.244.24ZM18.828-8.352a2.588,2.588,0,0,1,.936.216l.024-2.472a.64.64,0,0,0-.312-.12H19.4l-.192.024a3.98,3.98,0,0,0-2.928,1.128v-1.2H13.812V0h2.472V-6.912A3,3,0,0,1,18.828-8.352ZM29.82,0h3.024L27.4-6.456l4.872-4.488L29.2-10.968,24.948-7.1V-16.92H22.4V0h2.544V-4.536l.624-.5ZM45.612-8.664a3,3,0,0,1,1.56.432,3.324,3.324,0,0,1,1.488,2.9,3.646,3.646,0,0,1-.408,1.7,2.964,2.964,0,0,1-2.64,1.656A2.821,2.821,0,0,1,44.076-2.4a3.385,3.385,0,0,1-1.512-2.928,3.8,3.8,0,0,1,.408-1.7A2.914,2.914,0,0,1,45.612-8.664ZM45.948.384a5.13,5.13,0,0,0,2.688-.768A5.644,5.644,0,0,0,51.2-5.328a5.965,5.965,0,0,0-.672-2.9,5.071,5.071,0,0,0-4.584-2.784,4.478,4.478,0,0,0-3.36,1.44l-.216-1.2H40.164V4.8h2.544V-.936A4.4,4.4,0,0,0,45.948.384ZM59.2-8.352a2.588,2.588,0,0,1,.936.216l.024-2.472a.64.64,0,0,0-.312-.12h-.072l-.192.024a3.98,3.98,0,0,0-2.928,1.128v-1.2H54.18V0h2.472V-6.912A3,3,0,0,1,59.2-8.352Zm8.4-.336a2.821,2.821,0,0,1,1.56.432,3.254,3.254,0,0,1,1.488,2.88,3.549,3.549,0,0,1-.408,1.68A2.918,2.918,0,0,1,67.6-2.088,2.855,2.855,0,0,1,66.06-2.52a3.209,3.209,0,0,1-1.512-2.856,3.331,3.331,0,0,1,.432-1.7A2.883,2.883,0,0,1,67.6-8.688ZM67.6.24A5.7,5.7,0,0,0,70.452-.5a5.439,5.439,0,0,0,2.736-4.872,5.856,5.856,0,0,0-.72-2.9A5.439,5.439,0,0,0,67.6-11.016a5.674,5.674,0,0,0-2.856.72A5.516,5.516,0,0,0,62-5.376a5.7,5.7,0,0,0,.744,2.856A5.421,5.421,0,0,0,67.6.24ZM76.14-2.52A5.356,5.356,0,0,0,80.964.24,5.894,5.894,0,0,0,85.332-1.7l-1.656-1.7a3.788,3.788,0,0,1-2.712,1.32,2.855,2.855,0,0,1-1.536-.432A3.241,3.241,0,0,1,77.94-5.376a3.646,3.646,0,0,1,.408-1.7,2.883,2.883,0,0,1,2.616-1.608,3.66,3.66,0,0,1,2.5,1.128l1.656-1.728a6.042,6.042,0,0,0-4.152-1.728,5.461,5.461,0,0,0-2.832.72A5.516,5.516,0,0,0,75.4-5.376,5.7,5.7,0,0,0,76.14-2.52ZM89.6-6.552a2.883,2.883,0,0,1,2.688-2.184,2.915,2.915,0,0,1,2.736,2.184ZM97.572-4.3a8.14,8.14,0,0,0,.1-1.08,5.8,5.8,0,0,0-.72-2.856,5.251,5.251,0,0,0-4.656-2.784,5.068,5.068,0,0,0-2.712.744,5.651,5.651,0,0,0-2.664,4.9,5.6,5.6,0,0,0,.744,2.832A5.593,5.593,0,0,0,92.532.24a6.962,6.962,0,0,0,4.7-1.776l-1.56-1.728A4.523,4.523,0,0,1,92.508-2.04,3.09,3.09,0,0,1,89.58-4.3ZM99.3-1.512A6.556,6.556,0,0,0,103.668.24c2.424,0,4.08-1.32,4.08-3.36,0-1.7-1.08-2.76-3.264-3.408a6.64,6.64,0,0,1-1.776-.7.806.806,0,0,1-.408-.7c0-.576.48-.96,1.368-.96a3.84,3.84,0,0,1,2.5,1.128l1.32-1.848a5.815,5.815,0,0,0-3.792-1.416c-2.208,0-3.792,1.224-3.792,3.12,0,1.8,1.032,2.784,3.5,3.528a7.2,7.2,0,0,1,1.608.624.841.841,0,0,1,.336.672c0,.672-.624,1.152-1.68,1.152a4.227,4.227,0,0,1-3.024-1.464Zm10.152,0A6.556,6.556,0,0,0,113.82.24c2.424,0,4.08-1.32,4.08-3.36,0-1.7-1.08-2.76-3.264-3.408a6.64,6.64,0,0,1-1.776-.7.806.806,0,0,1-.408-.7c0-.576.48-.96,1.368-.96a3.84,3.84,0,0,1,2.5,1.128l1.32-1.848a5.815,5.815,0,0,0-3.792-1.416c-2.208,0-3.792,1.224-3.792,3.12,0,1.8,1.032,2.784,3.5,3.528a7.2,7.2,0,0,1,1.608.624.841.841,0,0,1,.336.672c0,.672-.624,1.152-1.68,1.152A4.227,4.227,0,0,1,110.8-3.384Zm13.176-5.04a2.883,2.883,0,0,1,2.688-2.184,2.915,2.915,0,0,1,2.736,2.184ZM130.6-4.3a8.141,8.141,0,0,0,.1-1.08,5.8,5.8,0,0,0-.72-2.856,5.251,5.251,0,0,0-4.656-2.784,5.068,5.068,0,0,0-2.712.744,5.651,5.651,0,0,0-2.664,4.9,5.6,5.6,0,0,0,.744,2.832A5.593,5.593,0,0,0,125.556.24a6.962,6.962,0,0,0,4.7-1.776L128.7-3.264a4.523,4.523,0,0,1-3.168,1.224A3.09,3.09,0,0,1,122.6-4.3Zm1.728,2.784A6.556,6.556,0,0,0,136.692.24c2.424,0,4.08-1.32,4.08-3.36,0-1.7-1.08-2.76-3.264-3.408a6.64,6.64,0,0,1-1.776-.7.806.806,0,0,1-.408-.7c0-.576.48-.96,1.368-.96a3.84,3.84,0,0,1,2.5,1.128l1.32-1.848a5.815,5.815,0,0,0-3.792-1.416c-2.208,0-3.792,1.224-3.792,3.12,0,1.8,1.032,2.784,3.5,3.528a7.2,7.2,0,0,1,1.608.624.841.841,0,0,1,.336.672c0,.672-.624,1.152-1.68,1.152a4.227,4.227,0,0,1-3.024-1.464Z"
              transform="translate(976 9718.5)"
              fill="#241a1b"
            />
            <path
              id="Path_6798"
              data-name="Path 6798"
              d="M-88.38-14.016c2.112,0,3.288,1.032,3.288,2.784s-1.1,2.76-3.288,2.76h-2.184v-5.544Zm-.072,7.968c3.672,0,6.024-1.992,6.024-5.184,0-3.264-2.28-5.208-6.024-5.208h-4.7V0h2.592V-6.048Zm13.92-2.3a2.588,2.588,0,0,1,.936.216l.024-2.472a.64.64,0,0,0-.312-.12h-.072l-.192.024a3.98,3.98,0,0,0-2.928,1.128v-1.2h-2.472V0h2.472V-6.912A3,3,0,0,1-74.532-8.352Zm8.4-.336a2.821,2.821,0,0,1,1.56.432,3.254,3.254,0,0,1,1.488,2.88,3.549,3.549,0,0,1-.408,1.68,2.918,2.918,0,0,1-2.64,1.608,2.855,2.855,0,0,1-1.536-.432A3.209,3.209,0,0,1-69.18-5.376a3.331,3.331,0,0,1,.432-1.7A2.883,2.883,0,0,1-66.132-8.688Zm0,8.928A5.7,5.7,0,0,0-63.276-.5,5.439,5.439,0,0,0-60.54-5.376a5.856,5.856,0,0,0-.72-2.9,5.439,5.439,0,0,0-4.872-2.736,5.674,5.674,0,0,0-2.856.72,5.516,5.516,0,0,0-2.736,4.92A5.7,5.7,0,0,0-70.98-2.52,5.421,5.421,0,0,0-66.132.24Zm9.48-11.112-2.256.12v2.184h2.136v4.776c0,2.5,1.392,4.032,3.624,4.032a4.4,4.4,0,0,0,3.216-1.464l-1.32-1.824a2.525,2.525,0,0,1-1.656.912c-.792,0-1.32-.6-1.32-1.68V-8.568H-50.7v-2.3h-3.528v-2.976h-2.16Zm13.9,2.184a2.821,2.821,0,0,1,1.56.432,3.254,3.254,0,0,1,1.488,2.88,3.549,3.549,0,0,1-.408,1.68,2.918,2.918,0,0,1-2.64,1.608,2.855,2.855,0,0,1-1.536-.432A3.209,3.209,0,0,1-45.8-5.376a3.331,3.331,0,0,1,.432-1.7A2.883,2.883,0,0,1-42.756-8.688Zm0,8.928A5.7,5.7,0,0,0-39.9-.5a5.439,5.439,0,0,0,2.736-4.872,5.856,5.856,0,0,0-.72-2.9,5.439,5.439,0,0,0-4.872-2.736,5.674,5.674,0,0,0-2.856.72,5.516,5.516,0,0,0-2.736,4.92A5.7,5.7,0,0,0-47.6-2.52,5.421,5.421,0,0,0-42.756.24Zm9.48-11.112-2.256.12v2.184H-33.4v4.776C-33.4-1.3-32,.24-29.772.24a4.4,4.4,0,0,0,3.216-1.464l-1.32-1.824a2.525,2.525,0,0,1-1.656.912c-.792,0-1.32-.6-1.32-1.68V-8.568h3.528v-2.3h-3.528v-2.976h-2.16ZM-19.764,5.04a6.261,6.261,0,0,0,2.928-.672,4.267,4.267,0,0,0,2.016-3V-10.776h-2.568v7.1a3.068,3.068,0,0,1-2.52,1.656c-1.32,0-2.04-.864-2.04-2.472v-6.288h-2.544v6.552c0,2.88,1.488,4.608,4.056,4.608a3.83,3.83,0,0,0,3.312-1.44c.024.216.024.528.024.912-.024,1.848-.408,2.472-1.176,2.64a11.2,11.2,0,0,1-2.088.24c-.984.048-1.608-.24-2.952-1.3l-1.248,1.968A6.627,6.627,0,0,0-19.764,5.04Zm14.256-13.7a3,3,0,0,1,1.56.432,3.324,3.324,0,0,1,1.488,2.9,3.646,3.646,0,0,1-.408,1.7,2.964,2.964,0,0,1-2.64,1.656A2.821,2.821,0,0,1-7.044-2.4,3.385,3.385,0,0,1-8.556-5.328a3.8,3.8,0,0,1,.408-1.7A2.914,2.914,0,0,1-5.508-8.664ZM-5.172.384A5.13,5.13,0,0,0-2.484-.384,5.644,5.644,0,0,0,.084-5.328a5.965,5.965,0,0,0-.672-2.9,5.071,5.071,0,0,0-4.584-2.784,4.478,4.478,0,0,0-3.36,1.44l-.216-1.2h-2.208V4.8h2.544V-.936A4.4,4.4,0,0,0-5.172.384ZM4.956-6.552A2.883,2.883,0,0,1,7.644-8.736,2.915,2.915,0,0,1,10.38-6.552ZM12.924-4.3a8.139,8.139,0,0,0,.1-1.08,5.8,5.8,0,0,0-.72-2.856,5.251,5.251,0,0,0-4.656-2.784,5.069,5.069,0,0,0-2.712.744,5.651,5.651,0,0,0-2.664,4.9,5.6,5.6,0,0,0,.744,2.832A5.593,5.593,0,0,0,7.884.24a6.962,6.962,0,0,0,4.7-1.776l-1.56-1.728A4.523,4.523,0,0,1,7.86-2.04,3.09,3.09,0,0,1,4.932-4.3Zm9.048-6.576-2.256.12v2.184h2.136v4.776c0,2.5,1.392,4.032,3.624,4.032a4.4,4.4,0,0,0,3.216-1.464l-1.32-1.824a2.525,2.525,0,0,1-1.656.912c-.792,0-1.32-.6-1.32-1.68V-8.568h3.528v-2.3H24.4v-2.976h-2.16ZM32.94-6.552a2.883,2.883,0,0,1,2.688-2.184,2.915,2.915,0,0,1,2.736,2.184ZM40.908-4.3a8.14,8.14,0,0,0,.1-1.08,5.8,5.8,0,0,0-.72-2.856,5.251,5.251,0,0,0-4.656-2.784,5.069,5.069,0,0,0-2.712.744,5.651,5.651,0,0,0-2.664,4.9A5.6,5.6,0,0,0,31-2.544,5.593,5.593,0,0,0,35.868.24a6.962,6.962,0,0,0,4.7-1.776l-1.56-1.728A4.523,4.523,0,0,1,35.844-2.04,3.09,3.09,0,0,1,32.916-4.3Zm1.728,2.784A6.556,6.556,0,0,0,47,.24c2.424,0,4.08-1.32,4.08-3.36,0-1.7-1.08-2.76-3.264-3.408a6.64,6.64,0,0,1-1.776-.7.806.806,0,0,1-.408-.7c0-.576.48-.96,1.368-.96a3.84,3.84,0,0,1,2.5,1.128L50.82-9.6a5.815,5.815,0,0,0-3.792-1.416c-2.208,0-3.792,1.224-3.792,3.12,0,1.8,1.032,2.784,3.5,3.528a7.2,7.2,0,0,1,1.608.624.841.841,0,0,1,.336.672c0,.672-.624,1.152-1.68,1.152A4.227,4.227,0,0,1,43.98-3.384Zm12.192-9.36-2.256.12v2.184h2.136v4.776C54.708-1.3,56.1.24,58.332.24a4.4,4.4,0,0,0,3.216-1.464l-1.32-1.824a2.525,2.525,0,0,1-1.656.912c-.792,0-1.32-.6-1.32-1.68V-8.568H60.78v-2.3H57.252v-2.976h-2.16ZM63.732,0h2.544V-10.92H63.732Zm-.168-14.064a1.554,1.554,0,0,0,1.416,1.632,1.556,1.556,0,0,0,1.44-1.632A1.556,1.556,0,0,0,64.98-15.7,1.554,1.554,0,0,0,63.564-14.064ZM77.148,0h2.544V-6.288c0-2.952-1.56-4.728-4.176-4.728a4.466,4.466,0,0,0-3.24,1.536l-.24-1.3H69.828V0h2.544V-6.912a3.229,3.229,0,0,1,2.64-1.728c1.344,0,2.136.96,2.136,2.616ZM88.212-8.664a3,3,0,0,1,1.56.432A3.366,3.366,0,0,1,91.26-5.3a3.508,3.508,0,0,1-.408,1.7,2.941,2.941,0,0,1-2.64,1.632A2.821,2.821,0,0,1,86.676-2.4a3.29,3.29,0,0,1-1.512-2.9,3.674,3.674,0,0,1,.408-1.728A2.941,2.941,0,0,1,88.212-8.664Zm.048,13.7a6.958,6.958,0,0,0,3.192-.672c1.872-.96,2.208-1.944,2.208-4.224v-10.92H91.452l-.216,1.2a4.478,4.478,0,0,0-3.36-1.44,4.872,4.872,0,0,0-2.688.744A5.715,5.715,0,0,0,82.62-5.3a5.945,5.945,0,0,0,.7,2.88A5.083,5.083,0,0,0,87.876.384a4.605,4.605,0,0,0,3.648-1.776V.144c0,1.752-1.032,2.568-3.336,2.568a5.535,5.535,0,0,1-1.824-.264A6.694,6.694,0,0,1,84.516,1.2L83.172,3.144a7.487,7.487,0,0,0,2.376,1.512A8.208,8.208,0,0,0,88.26,5.04Z"
              transform="translate(1201 8890.5)"
              fill="#241a1b"
            />
            <path
              id="Path_6799"
              data-name="Path 6799"
              d="M-132.12,0h2.64V-16.44h-2.64ZM-118.1,0h2.544V-6.288c0-2.952-1.56-4.728-4.176-4.728a4.466,4.466,0,0,0-3.24,1.536l-.24-1.3h-2.208V0h2.544V-6.912a3.229,3.229,0,0,1,2.64-1.728c1.344,0,2.136.96,2.136,2.616Zm6.5-12.672a15.572,15.572,0,0,0,.1,1.728l-1.944.12V-8.64h2.208V0h2.52V-8.64h3.24v-2.3h-3.528V-12.96c0-1.32.336-1.824,1.2-1.824.48,0,.72.144,1.56.888l1.248-1.9a4.681,4.681,0,0,0-3.1-1.368C-110.424-17.16-111.6-15.672-111.6-12.672Zm13.152,3.984a2.821,2.821,0,0,1,1.56.432A3.254,3.254,0,0,1-95.4-5.376a3.549,3.549,0,0,1-.408,1.68,2.918,2.918,0,0,1-2.64,1.608,2.855,2.855,0,0,1-1.536-.432A3.209,3.209,0,0,1-101.5-5.376a3.331,3.331,0,0,1,.432-1.7A2.883,2.883,0,0,1-98.448-8.688Zm0,8.928A5.7,5.7,0,0,0-95.592-.5a5.439,5.439,0,0,0,2.736-4.872,5.856,5.856,0,0,0-.72-2.9,5.439,5.439,0,0,0-4.872-2.736,5.674,5.674,0,0,0-2.856.72,5.516,5.516,0,0,0-2.736,4.92A5.7,5.7,0,0,0-103.3-2.52,5.421,5.421,0,0,0-98.448.24Zm13.584-8.592a2.588,2.588,0,0,1,.936.216l.024-2.472a.64.64,0,0,0-.312-.12h-.072l-.192.024a3.98,3.98,0,0,0-2.928,1.128v-1.2H-89.88V0h2.472V-6.912A3,3,0,0,1-84.864-8.352ZM-66.816,0h2.592V-6.288c0-2.952-1.536-4.728-4.128-4.728a4.94,4.94,0,0,0-3.72,1.9,3.951,3.951,0,0,0-3.528-1.9A4.378,4.378,0,0,0-78.792-9.5l-.24-1.272h-2.256V0H-78.7V-6.912a3.106,3.106,0,0,1,2.568-1.752c1.32,0,2.088.912,2.088,2.64V0h2.568V-6.7c.744-1.32,1.584-1.968,2.568-1.968,1.32,0,2.088.912,2.088,2.64Zm10.968-8.688a2.821,2.821,0,0,1,1.56.432A3.282,3.282,0,0,1-52.8-5.376a3.413,3.413,0,0,1-.408,1.68,2.918,2.918,0,0,1-2.64,1.608,2.855,2.855,0,0,1-1.536-.432A3.209,3.209,0,0,1-58.9-5.376a3.646,3.646,0,0,1,.408-1.7A2.918,2.918,0,0,1-55.848-8.688ZM-52.9,0h2.5V-10.776h-2.208l-.216,1.2a4.478,4.478,0,0,0-3.36-1.44,5.123,5.123,0,0,0-2.688.72,5.661,5.661,0,0,0-2.568,4.92,5.918,5.918,0,0,0,.7,2.856A5.039,5.039,0,0,0-56.184.24,4.586,4.586,0,0,0-52.9-1.1Zm7.152-10.872-2.256.12v2.184h2.136v4.776c0,2.5,1.392,4.032,3.624,4.032a4.4,4.4,0,0,0,3.216-1.464l-1.32-1.824A2.525,2.525,0,0,1-42-2.136c-.792,0-1.32-.6-1.32-1.68V-8.568h3.528v-2.3H-43.32v-2.976h-2.16ZM-36.84,0H-34.3V-10.92H-36.84Zm-.168-14.064a1.554,1.554,0,0,0,1.416,1.632,1.556,1.556,0,0,0,1.44-1.632,1.556,1.556,0,0,0-1.44-1.632A1.554,1.554,0,0,0-37.008-14.064ZM-25.92-8.688a2.821,2.821,0,0,1,1.56.432,3.254,3.254,0,0,1,1.488,2.88A3.549,3.549,0,0,1-23.28-3.7a2.918,2.918,0,0,1-2.64,1.608,2.855,2.855,0,0,1-1.536-.432,3.209,3.209,0,0,1-1.512-2.856,3.331,3.331,0,0,1,.432-1.7A2.883,2.883,0,0,1-25.92-8.688Zm0,8.928A5.7,5.7,0,0,0-23.064-.5a5.439,5.439,0,0,0,2.736-4.872,5.856,5.856,0,0,0-.72-2.9,5.439,5.439,0,0,0-4.872-2.736,5.674,5.674,0,0,0-2.856.72,5.516,5.516,0,0,0-2.736,4.92,5.7,5.7,0,0,0,.744,2.856A5.421,5.421,0,0,0-25.92.24ZM-10.032,0h2.544V-6.288c0-2.952-1.56-4.728-4.176-4.728A4.466,4.466,0,0,0-14.9-9.48l-.24-1.3h-2.208V0h2.544V-6.912a3.229,3.229,0,0,1,2.64-1.728c1.344,0,2.136.96,2.136,2.616ZM7.68-12.888,10.248-6.48H5.112ZM12.84,0h2.784L8.952-16.44H6.5L-.192,0H2.52L4.128-4.056h7.08ZM22.848-8.352a2.588,2.588,0,0,1,.936.216l.024-2.472a.64.64,0,0,0-.312-.12h-.072l-.192.024A3.98,3.98,0,0,0,20.3-9.576v-1.2H17.832V0H20.3V-6.912A3,3,0,0,1,22.848-8.352ZM26.4-2.52A5.356,5.356,0,0,0,31.224.24,5.894,5.894,0,0,0,35.592-1.7l-1.656-1.7a3.788,3.788,0,0,1-2.712,1.32,2.855,2.855,0,0,1-1.536-.432A3.241,3.241,0,0,1,28.2-5.376a3.646,3.646,0,0,1,.408-1.7,2.883,2.883,0,0,1,2.616-1.608,3.66,3.66,0,0,1,2.5,1.128l1.656-1.728a6.042,6.042,0,0,0-4.152-1.728,5.461,5.461,0,0,0-2.832.72,5.516,5.516,0,0,0-2.736,4.92A5.7,5.7,0,0,0,26.4-2.52ZM45.288,0h2.52V-6.36c0-2.976-1.56-4.824-4.152-4.824a4.285,4.285,0,0,0-3.144,1.44V-16.92H37.968V0h2.544V-7.008a3.205,3.205,0,0,1,2.616-1.776c1.344,0,2.16.96,2.16,2.664Zm5.9,0h2.544V-10.92H51.192Zm-.168-14.064a1.554,1.554,0,0,0,1.416,1.632,1.556,1.556,0,0,0,1.44-1.632A1.556,1.556,0,0,0,52.44-15.7,1.554,1.554,0,0,0,51.024-14.064ZM58.2-10.872l-2.256.12v2.184H58.08v4.776C58.08-1.3,59.472.24,61.7.24A4.4,4.4,0,0,0,64.92-1.224L63.6-3.048a2.525,2.525,0,0,1-1.656.912c-.792,0-1.32-.6-1.32-1.68V-8.568h3.528v-2.3H60.624v-2.976h-2.16Zm10.968,4.32a2.883,2.883,0,0,1,2.688-2.184,2.915,2.915,0,0,1,2.736,2.184ZM77.136-4.3a8.14,8.14,0,0,0,.1-1.08,5.8,5.8,0,0,0-.72-2.856,5.251,5.251,0,0,0-4.656-2.784,5.068,5.068,0,0,0-2.712.744,5.651,5.651,0,0,0-2.664,4.9,5.6,5.6,0,0,0,.744,2.832A5.593,5.593,0,0,0,72.1.24a6.962,6.962,0,0,0,4.7-1.776L75.24-3.264A4.523,4.523,0,0,1,72.072-2.04,3.09,3.09,0,0,1,69.144-4.3ZM79.968-2.52A5.356,5.356,0,0,0,84.792.24,5.894,5.894,0,0,0,89.16-1.7L87.5-3.408a3.788,3.788,0,0,1-2.712,1.32,2.855,2.855,0,0,1-1.536-.432,3.241,3.241,0,0,1-1.488-2.856,3.646,3.646,0,0,1,.408-1.7,2.883,2.883,0,0,1,2.616-1.608,3.66,3.66,0,0,1,2.5,1.128l1.656-1.728a6.042,6.042,0,0,0-4.152-1.728,5.461,5.461,0,0,0-2.832.72,5.516,5.516,0,0,0-2.736,4.92A5.7,5.7,0,0,0,79.968-2.52Zm12.48-8.352-2.256.12v2.184h2.136v4.776C92.328-1.3,93.72.24,95.952.24a4.4,4.4,0,0,0,3.216-1.464l-1.32-1.824a2.525,2.525,0,0,1-1.656.912c-.792,0-1.32-.6-1.32-1.68V-8.568H98.4v-2.3H94.872v-2.976h-2.16ZM108.432,0H111V-10.776h-2.568v7.008a3.038,3.038,0,0,1-2.52,1.632c-1.32,0-2.04-.864-2.04-2.424v-6.216h-2.544V-4.32c0,2.856,1.488,4.56,4.056,4.56a4.374,4.374,0,0,0,3.072-1.32ZM119.76-8.352a2.588,2.588,0,0,1,.936.216l.024-2.472a.64.64,0,0,0-.312-.12h-.072l-.192.024a3.98,3.98,0,0,0-2.928,1.128v-1.2h-2.472V0h2.472V-6.912A3,3,0,0,1,119.76-8.352Zm5.472,1.8a2.883,2.883,0,0,1,2.688-2.184,2.915,2.915,0,0,1,2.736,2.184ZM133.2-4.3a8.141,8.141,0,0,0,.1-1.08,5.8,5.8,0,0,0-.72-2.856,5.251,5.251,0,0,0-4.656-2.784,5.068,5.068,0,0,0-2.712.744,5.651,5.651,0,0,0-2.664,4.9,5.6,5.6,0,0,0,.744,2.832A5.593,5.593,0,0,0,128.16.24a6.962,6.962,0,0,0,4.7-1.776L131.3-3.264a4.523,4.523,0,0,1-3.168,1.224A3.09,3.09,0,0,1,125.208-4.3Z"
              transform="translate(752 8890.5)"
              fill="#241a1b"
            />
          </g>
          <g
            id="Group_7360"
            data-name="Group 7360"
            transform="translate(77.094 -536)"
          >
            <g
              id="Group_7290"
              data-name="Group 7290"
              transform="translate(14.122 -198.5)"
            >
              <circle
                id="Ellipse_775"
                data-name="Ellipse 775"
                cx="41.5"
                cy="41.5"
                r="41.5"
                transform="translate(1489.878 8889.327)"
                fill="#00a651"
              />
            </g>
            <g
              id="Group_3"
              data-name="Group 3"
              transform="translate(218 3336)"
              clip-path="url(#clip-path)"
            >
              <circle
                id="Ellipse_74"
                data-name="Ellipse 74"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1170 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_75"
                data-name="Ellipse 75"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1170 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_76"
                data-name="Ellipse 76"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1170 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_77"
                data-name="Ellipse 77"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1170 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_78"
                data-name="Ellipse 78"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1170 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_79"
                data-name="Ellipse 79"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1170 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_80"
                data-name="Ellipse 80"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1170 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_81"
                data-name="Ellipse 81"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1170 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_82"
                data-name="Ellipse 82"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1192 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_83"
                data-name="Ellipse 83"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1192 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_84"
                data-name="Ellipse 84"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1192 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_85"
                data-name="Ellipse 85"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1192 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_86"
                data-name="Ellipse 86"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1192 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_87"
                data-name="Ellipse 87"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1192 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_88"
                data-name="Ellipse 88"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1192 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_89"
                data-name="Ellipse 89"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1192 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_90"
                data-name="Ellipse 90"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1214 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_91"
                data-name="Ellipse 91"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1214 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_92"
                data-name="Ellipse 92"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1214 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_93"
                data-name="Ellipse 93"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1214 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_94"
                data-name="Ellipse 94"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1214 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_95"
                data-name="Ellipse 95"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1214 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_96"
                data-name="Ellipse 96"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1214 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_97"
                data-name="Ellipse 97"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1214 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_98"
                data-name="Ellipse 98"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1236 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_99"
                data-name="Ellipse 99"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1236 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_100"
                data-name="Ellipse 100"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1236 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_101"
                data-name="Ellipse 101"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1236 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_102"
                data-name="Ellipse 102"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1236 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_103"
                data-name="Ellipse 103"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1236 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_104"
                data-name="Ellipse 104"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1236 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_105"
                data-name="Ellipse 105"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1236 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_106"
                data-name="Ellipse 106"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1258 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_107"
                data-name="Ellipse 107"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1258 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_108"
                data-name="Ellipse 108"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1258 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_109"
                data-name="Ellipse 109"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1258 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_110"
                data-name="Ellipse 110"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1258 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_111"
                data-name="Ellipse 111"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1258 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_112"
                data-name="Ellipse 112"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1258 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_113"
                data-name="Ellipse 113"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1258 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_114"
                data-name="Ellipse 114"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1280 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_115"
                data-name="Ellipse 115"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1280 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_116"
                data-name="Ellipse 116"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1280 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_117"
                data-name="Ellipse 117"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1280 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_118"
                data-name="Ellipse 118"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1280 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_119"
                data-name="Ellipse 119"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1280 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_120"
                data-name="Ellipse 120"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1280 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_121"
                data-name="Ellipse 121"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1280 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_122"
                data-name="Ellipse 122"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1302 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_123"
                data-name="Ellipse 123"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1302 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_124"
                data-name="Ellipse 124"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1302 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_125"
                data-name="Ellipse 125"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1302 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_126"
                data-name="Ellipse 126"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1302 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_127"
                data-name="Ellipse 127"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1302 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_128"
                data-name="Ellipse 128"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1302 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_129"
                data-name="Ellipse 129"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1302 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_130"
                data-name="Ellipse 130"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1324 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_131"
                data-name="Ellipse 131"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1324 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_132"
                data-name="Ellipse 132"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1324 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_133"
                data-name="Ellipse 133"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1324 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_134"
                data-name="Ellipse 134"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1324 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_135"
                data-name="Ellipse 135"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1324 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_136"
                data-name="Ellipse 136"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1324 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_137"
                data-name="Ellipse 137"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1324 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_138"
                data-name="Ellipse 138"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1346 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_139"
                data-name="Ellipse 139"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1346 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_140"
                data-name="Ellipse 140"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1346 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_141"
                data-name="Ellipse 141"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1346 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_142"
                data-name="Ellipse 142"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1346 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_143"
                data-name="Ellipse 143"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1346 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_144"
                data-name="Ellipse 144"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1346 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_145"
                data-name="Ellipse 145"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1346 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_146"
                data-name="Ellipse 146"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1368 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_147"
                data-name="Ellipse 147"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1368 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_148"
                data-name="Ellipse 148"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1368 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_149"
                data-name="Ellipse 149"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1368 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_150"
                data-name="Ellipse 150"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1368 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_151"
                data-name="Ellipse 151"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1368 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_152"
                data-name="Ellipse 152"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1368 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_153"
                data-name="Ellipse 153"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1368 5291)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_154"
                data-name="Ellipse 154"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1390 5137)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_155"
                data-name="Ellipse 155"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1390 5159)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_156"
                data-name="Ellipse 156"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1390 5181)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_157"
                data-name="Ellipse 157"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1390 5203)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_158"
                data-name="Ellipse 158"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1390 5225)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_159"
                data-name="Ellipse 159"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1390 5247)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_160"
                data-name="Ellipse 160"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1390 5269)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_161"
                data-name="Ellipse 161"
                cx="3"
                cy="3"
                r="3"
                transform="translate(1390 5291)"
                fill="#d5d5d5"
              />
            </g>
            <circle
              id="Ellipse_162"
              data-name="Ellipse 162"
              cx="97.5"
              cy="97.5"
              r="97.5"
              transform="translate(1366 8513)"
              fill="#fdb913"
            />
          </g>
          <g
            id="Group_7361"
            data-name="Group 7361"
            transform="translate(327.094 8906)"
          >
            <g
              id="Group_7290-2"
              data-name="Group 7290"
              transform="translate(27)"
            >
              <circle
                id="Ellipse_775-2"
                data-name="Ellipse 775"
                cx="41.5"
                cy="41.5"
                r="41.5"
                fill="#4a8af5"
              />
            </g>
            <g
              id="Group_3-2"
              data-name="Group 3"
              transform="translate(0 130.827)"
              clip-path="url(#clip-path-2)"
            >
              <circle
                id="Ellipse_74-2"
                data-name="Ellipse 74"
                cx="3"
                cy="3"
                r="3"
                transform="translate(220 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_75-2"
                data-name="Ellipse 75"
                cx="3"
                cy="3"
                r="3"
                transform="translate(220 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_76-2"
                data-name="Ellipse 76"
                cx="3"
                cy="3"
                r="3"
                transform="translate(220 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_77-2"
                data-name="Ellipse 77"
                cx="3"
                cy="3"
                r="3"
                transform="translate(220 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_78-2"
                data-name="Ellipse 78"
                cx="3"
                cy="3"
                r="3"
                transform="translate(220 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_79-2"
                data-name="Ellipse 79"
                cx="3"
                cy="3"
                r="3"
                transform="translate(220 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_80-2"
                data-name="Ellipse 80"
                cx="3"
                cy="3"
                r="3"
                transform="translate(220 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_81-2"
                data-name="Ellipse 81"
                cx="3"
                cy="3"
                r="3"
                transform="translate(220 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_82-2"
                data-name="Ellipse 82"
                cx="3"
                cy="3"
                r="3"
                transform="translate(198 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_83-2"
                data-name="Ellipse 83"
                cx="3"
                cy="3"
                r="3"
                transform="translate(198 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_84-2"
                data-name="Ellipse 84"
                cx="3"
                cy="3"
                r="3"
                transform="translate(198 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_85-2"
                data-name="Ellipse 85"
                cx="3"
                cy="3"
                r="3"
                transform="translate(198 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_86-2"
                data-name="Ellipse 86"
                cx="3"
                cy="3"
                r="3"
                transform="translate(198 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_87-2"
                data-name="Ellipse 87"
                cx="3"
                cy="3"
                r="3"
                transform="translate(198 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_88-2"
                data-name="Ellipse 88"
                cx="3"
                cy="3"
                r="3"
                transform="translate(198 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_89-2"
                data-name="Ellipse 89"
                cx="3"
                cy="3"
                r="3"
                transform="translate(198 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_90-2"
                data-name="Ellipse 90"
                cx="3"
                cy="3"
                r="3"
                transform="translate(176 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_91-2"
                data-name="Ellipse 91"
                cx="3"
                cy="3"
                r="3"
                transform="translate(176 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_92-2"
                data-name="Ellipse 92"
                cx="3"
                cy="3"
                r="3"
                transform="translate(176 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_93-2"
                data-name="Ellipse 93"
                cx="3"
                cy="3"
                r="3"
                transform="translate(176 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_94-2"
                data-name="Ellipse 94"
                cx="3"
                cy="3"
                r="3"
                transform="translate(176 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_95-2"
                data-name="Ellipse 95"
                cx="3"
                cy="3"
                r="3"
                transform="translate(176 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_96-2"
                data-name="Ellipse 96"
                cx="3"
                cy="3"
                r="3"
                transform="translate(176 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_97-2"
                data-name="Ellipse 97"
                cx="3"
                cy="3"
                r="3"
                transform="translate(176 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_98-2"
                data-name="Ellipse 98"
                cx="3"
                cy="3"
                r="3"
                transform="translate(154 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_99-2"
                data-name="Ellipse 99"
                cx="3"
                cy="3"
                r="3"
                transform="translate(154 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_100-2"
                data-name="Ellipse 100"
                cx="3"
                cy="3"
                r="3"
                transform="translate(154 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_101-2"
                data-name="Ellipse 101"
                cx="3"
                cy="3"
                r="3"
                transform="translate(154 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_102-2"
                data-name="Ellipse 102"
                cx="3"
                cy="3"
                r="3"
                transform="translate(154 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_103-2"
                data-name="Ellipse 103"
                cx="3"
                cy="3"
                r="3"
                transform="translate(154 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_104-2"
                data-name="Ellipse 104"
                cx="3"
                cy="3"
                r="3"
                transform="translate(154 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_105-2"
                data-name="Ellipse 105"
                cx="3"
                cy="3"
                r="3"
                transform="translate(154 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_106-2"
                data-name="Ellipse 106"
                cx="3"
                cy="3"
                r="3"
                transform="translate(132 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_107-2"
                data-name="Ellipse 107"
                cx="3"
                cy="3"
                r="3"
                transform="translate(132 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_108-2"
                data-name="Ellipse 108"
                cx="3"
                cy="3"
                r="3"
                transform="translate(132 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_109-2"
                data-name="Ellipse 109"
                cx="3"
                cy="3"
                r="3"
                transform="translate(132 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_110-2"
                data-name="Ellipse 110"
                cx="3"
                cy="3"
                r="3"
                transform="translate(132 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_111-2"
                data-name="Ellipse 111"
                cx="3"
                cy="3"
                r="3"
                transform="translate(132 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_112-2"
                data-name="Ellipse 112"
                cx="3"
                cy="3"
                r="3"
                transform="translate(132 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_113-2"
                data-name="Ellipse 113"
                cx="3"
                cy="3"
                r="3"
                transform="translate(132 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_114-2"
                data-name="Ellipse 114"
                cx="3"
                cy="3"
                r="3"
                transform="translate(110 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_115-2"
                data-name="Ellipse 115"
                cx="3"
                cy="3"
                r="3"
                transform="translate(110 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_116-2"
                data-name="Ellipse 116"
                cx="3"
                cy="3"
                r="3"
                transform="translate(110 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_117-2"
                data-name="Ellipse 117"
                cx="3"
                cy="3"
                r="3"
                transform="translate(110 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_118-2"
                data-name="Ellipse 118"
                cx="3"
                cy="3"
                r="3"
                transform="translate(110 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_119-2"
                data-name="Ellipse 119"
                cx="3"
                cy="3"
                r="3"
                transform="translate(110 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_120-2"
                data-name="Ellipse 120"
                cx="3"
                cy="3"
                r="3"
                transform="translate(110 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_121-2"
                data-name="Ellipse 121"
                cx="3"
                cy="3"
                r="3"
                transform="translate(110 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_122-2"
                data-name="Ellipse 122"
                cx="3"
                cy="3"
                r="3"
                transform="translate(88 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_123-2"
                data-name="Ellipse 123"
                cx="3"
                cy="3"
                r="3"
                transform="translate(88 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_124-2"
                data-name="Ellipse 124"
                cx="3"
                cy="3"
                r="3"
                transform="translate(88 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_125-2"
                data-name="Ellipse 125"
                cx="3"
                cy="3"
                r="3"
                transform="translate(88 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_126-2"
                data-name="Ellipse 126"
                cx="3"
                cy="3"
                r="3"
                transform="translate(88 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_127-2"
                data-name="Ellipse 127"
                cx="3"
                cy="3"
                r="3"
                transform="translate(88 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_128-2"
                data-name="Ellipse 128"
                cx="3"
                cy="3"
                r="3"
                transform="translate(88 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_129-2"
                data-name="Ellipse 129"
                cx="3"
                cy="3"
                r="3"
                transform="translate(88 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_130-2"
                data-name="Ellipse 130"
                cx="3"
                cy="3"
                r="3"
                transform="translate(66 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_131-2"
                data-name="Ellipse 131"
                cx="3"
                cy="3"
                r="3"
                transform="translate(66 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_132-2"
                data-name="Ellipse 132"
                cx="3"
                cy="3"
                r="3"
                transform="translate(66 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_133-2"
                data-name="Ellipse 133"
                cx="3"
                cy="3"
                r="3"
                transform="translate(66 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_134-2"
                data-name="Ellipse 134"
                cx="3"
                cy="3"
                r="3"
                transform="translate(66 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_135-2"
                data-name="Ellipse 135"
                cx="3"
                cy="3"
                r="3"
                transform="translate(66 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_136-2"
                data-name="Ellipse 136"
                cx="3"
                cy="3"
                r="3"
                transform="translate(66 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_137-2"
                data-name="Ellipse 137"
                cx="3"
                cy="3"
                r="3"
                transform="translate(66 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_138-2"
                data-name="Ellipse 138"
                cx="3"
                cy="3"
                r="3"
                transform="translate(44 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_139-2"
                data-name="Ellipse 139"
                cx="3"
                cy="3"
                r="3"
                transform="translate(44 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_140-2"
                data-name="Ellipse 140"
                cx="3"
                cy="3"
                r="3"
                transform="translate(44 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_141-2"
                data-name="Ellipse 141"
                cx="3"
                cy="3"
                r="3"
                transform="translate(44 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_142-2"
                data-name="Ellipse 142"
                cx="3"
                cy="3"
                r="3"
                transform="translate(44 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_143-2"
                data-name="Ellipse 143"
                cx="3"
                cy="3"
                r="3"
                transform="translate(44 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_144-2"
                data-name="Ellipse 144"
                cx="3"
                cy="3"
                r="3"
                transform="translate(44 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_145-2"
                data-name="Ellipse 145"
                cx="3"
                cy="3"
                r="3"
                transform="translate(44 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_146-2"
                data-name="Ellipse 146"
                cx="3"
                cy="3"
                r="3"
                transform="translate(22 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_147-2"
                data-name="Ellipse 147"
                cx="3"
                cy="3"
                r="3"
                transform="translate(22 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_148-2"
                data-name="Ellipse 148"
                cx="3"
                cy="3"
                r="3"
                transform="translate(22 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_149-2"
                data-name="Ellipse 149"
                cx="3"
                cy="3"
                r="3"
                transform="translate(22 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_150-2"
                data-name="Ellipse 150"
                cx="3"
                cy="3"
                r="3"
                transform="translate(22 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_151-2"
                data-name="Ellipse 151"
                cx="3"
                cy="3"
                r="3"
                transform="translate(22 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_152-2"
                data-name="Ellipse 152"
                cx="3"
                cy="3"
                r="3"
                transform="translate(22 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_153-2"
                data-name="Ellipse 153"
                cx="3"
                cy="3"
                r="3"
                transform="translate(22 10)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_154-2"
                data-name="Ellipse 154"
                cx="3"
                cy="3"
                r="3"
                transform="translate(0 164)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_155-2"
                data-name="Ellipse 155"
                cx="3"
                cy="3"
                r="3"
                transform="translate(0 142)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_156-2"
                data-name="Ellipse 156"
                cx="3"
                cy="3"
                r="3"
                transform="translate(0 120)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_157-2"
                data-name="Ellipse 157"
                cx="3"
                cy="3"
                r="3"
                transform="translate(0 98)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_158-2"
                data-name="Ellipse 158"
                cx="3"
                cy="3"
                r="3"
                transform="translate(0 76)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_159-2"
                data-name="Ellipse 159"
                cx="3"
                cy="3"
                r="3"
                transform="translate(0 54)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_160-2"
                data-name="Ellipse 160"
                cx="3"
                cy="3"
                r="3"
                transform="translate(0 32)"
                fill="#d5d5d5"
              />
              <circle
                id="Ellipse_161-2"
                data-name="Ellipse 161"
                cx="3"
                cy="3"
                r="3"
                transform="translate(0 10)"
                fill="#d5d5d5"
              />
            </g>
            <circle
              id="Ellipse_162-2"
              data-name="Ellipse 162"
              cx="97.5"
              cy="97.5"
              r="97.5"
              transform="translate(53 65.827)"
              fill="#241a1b"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}
